import { container } from "tsyringe";
import "reflect-metadata";
import { UserClient } from "./userClient";
import { UserDTO } from "../../generated-client/models";

export class UsersService {
	private readonly userClient: UserClient = container.resolve(UserClient);

	public async getAllUsers(): Promise<UserDTO[]> {
		return await this.userClient.usersApi.usersControllerFindAll();
	}

	public async getAllCompanyUsers(cardCode: string): Promise<UserDTO[]> {
		return await this.userClient.usersApi.usersControllerFindAllCompanyUsers({
			cardCode: cardCode,
		});
	}

	public async createUser(userDto: UserDTO) {
		return await this.userClient.usersApi.usersControllerCreate({
			userDTO: userDto,
		});
	}
	public async updateUser(userDto: UserDTO) {
		return await this.userClient.usersApi.usersControllerUpdate({
			email: userDto.email,
			userDTO: userDto,
		});
	}
}
